<template>
  <div>
    <section v-if="gardenTrail.details">
      <vue-headful :title="gardenTrail.details.name" :description="gardenTrail.details.summary" url="url"/>
      <DetailHeader :Title="gardenTrail.details.name"
            :City="gardenTrail.city"
            :Description="this.summary"
            :Breadcrumbs="this.Breadcrumbs"
            :Image="this.image" :ImageAlt="gardenTrail.details.name"
            :Website="gardenTrail.website" Region="trail-detail"/>
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-6 toc-region">
              <div class="road-trip--toc">
                <h3 class="road-trip--toc-h3">Table of Contents</h3>
                  <ol id="toc">
                  </ol>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- <div class="col-lg-6 mt-5 mb-5 map-container"><img src="/images/trails/map-place-holder.png" class="trail-map img-fluid"/></div> -->
            <div class="col-lg-12 text-left mt-5 mb-5 api-wrapper">
              <div v-for="(trail, index) in gardenTrail.trails" :key="index">
                  <h3 class="text-center road-trip--h3" :id="trail.name">{{trail.name}}</h3>
                  <div class="city-name text-center">{{trail.location}}</div>
                  <img :src="`https://alabama-travel.s3.amazonaws.com/uploads/garden/main_image/${trail.id}/${trail.main_image}`" class="img-fluid mt-3 mb-3"/>
                  <span v-html="trail.dont_miss" class="dont-miss"></span>
                  <button><a :href="`https://alabama.travel/places-to-go/${trail.slug}`"> Read More</a></button>
                  <h3 class="mt-5"> Nearby Road Trips </h3>
                  <div v-if="trail.gardens_road_trips" class="row">
                    <div v-for="(trip, index) in trail.gardens_road_trips" :key="index" class="col-lg-3">
                       <div v-if="trip.road_trip">
                        <router-link :to='"/road-trips/" + trip.road_trip.slug'>
                          <img :src="`https://alabama-travel.s3.amazonaws.com/uploads/road_trip/thumbnail_image/${trip.road_trip_id}/${trip.road_trip.main_image}`" class="img-fluid"/>
                          <div class="rt-number"> Alabama Road Trip No. {{trip.road_trip.trip_number}}</div>
                          <span>{{trip.road_trip.teaser}}</span>
                        </router-link>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
    </section>
    <Footer/>
  </div>
</template>

<script>
import {
  Vue, Component,
} from 'vue-property-decorator';
import axios from 'axios';
import Butter from 'buttercms';
import DetailHeader from '@/components/PlacesToGo/Common/DetailHeader.vue';
import Footer from '@/components/Common/Footer.vue';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

function setTOC() {
  const h3IDs = document.getElementsByClassName('road-trip--h3');
  let tocList = '';

  for (let x = 0; x < h3IDs.length; x++) {
    const title = h3IDs[x].innerHTML;
    const url = h3IDs[x].getAttribute('id');
    tocList = `${tocList}<li><a href="#${url}">${title}</a></li>`;
  }
  document.getElementById('toc').innerHTML = tocList;
}

@Component({
  components: {
    DetailHeader,
    Footer,
  },
  data() {
    return {
      gardenTrail: {},
      page: {
        fields: {},
      },
    };
  },
  methods: {
    getPage() {
      butter.page.retrieve('*', 'garden-trail', { preview: `${process.env.VUE_APP_BUTTER_PREVIEW}` })
        .then((res) => {
          this.page = res.data.data;
          this.summary = this.page.fields.summary;
          this.image = this.page.fields.image;
        }).catch((res) => {
          console.log(res);
        });
    },
  },
  async created() {
    await this.getPage();
    await this.GetGardenTrailDetail();
    setTOC();
  },
})
class GardenTrail extends Vue {
  async GetGardenTrailDetail() {
    const response = await axios.get(`${process.env.VUE_APP_TRAILS_API}trail/garden-trail`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
      },
    });
    this.gardenTrail = response.data;
  }

  get Breadcrumbs() {
    return [
      {
        text: 'Trails',
        href: '/trails',
      },
      {
        text: this.gardenTrail.details.name,
        active: true,
      },
    ];
  }
}

export default GardenTrail;
</script>

<style scoped>
.toc-region {
  padding-left:80px;
}
ol >>> li {
  text-align:left!important;
}
.road-trip--toc-h3 {
  margin-top: 30px;
  font-family: 'IdealSans-Book';
}
.border-left {
  border-left:solid 2px #979797!important;
}
.map-container {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  height:inherit;
}
.trail-map {
  position: -webkit-sticky;
  position: sticky;
  top: 1rem;
  align-self: flex-start;
}
.city-name {
  font-size: 22px;
}
.dont-miss >>> h5 {
  display:inline-block!important;
  font-weight:700;
}
.api-wrapper >>> button a {
  color:#ffffff;
}
.api-wrapper >>> button {
  background-color: #4e97b2;
  border: none;
  border-radius: 5px;
  color: #ffffff!important;
  display: inline-block;
  font-family: 'IdealSans-Medium';
  font-size: 1.1rem;
  font-weight: 500;
  min-height: 50px;
  padding: 15px 35px 10px 25px;
  position: relative;
  transition: background-color 500ms;
  text-decoration: underline;
}
.api-wrapper >>> button.no-carrot {
  padding: 15px 25px;
}

.api-wrapper >>> button:hover,
.api-wrapper >>> button:active,
.api-wrapper >>> button:focus {
  background-color: #357e99;
  color: #ffffff;
  transition: background-color 500ms;
}
.rt-number {
  font-size:14px;
  margin-top:10px;
}
.api-wrapper a {
  color:#173945;
  display:block;
}
.api-wrapper >>> h3 {
  margin-top:40px;
}
@media only screen and (max-width: 768px) {

  .toc-region {
  padding-left:0px;
}
  div >>> .region-left {
  padding-top:100px!important;
}
}
</style>
